module.exports = __webpack_public_path__ + "static/media/014-empty battery.3743c576.svg";